import { NewCard } from "@components/Cards/Templates/newCard";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import messages from "@constants/Messages";
import {
  handleNumericalCheck,
  phoneNumberChange,
} from "@services/ErrorHandling";
import { handlePostCodeChange } from "@services/ErrorHandling";
import { TenantFieldErrorMessages } from "@constants/Errors";
import { handleGenericCheck } from "@services/ErrorHandling";

type ContactCompanyInfoCardProps = {
  contactData: any;
  updateUserData: (field: string, value: any) => void;
  errors: any;
  updateError: (field: string, value: any) => void;
  isViewingHistory: boolean;
};

export const ContactCompanyInfoCard = ({
  contactData,
  updateUserData,
  errors,
  updateError,
  isViewingHistory,
}: ContactCompanyInfoCardProps) => {
  return (
    <NewCard
      header="企業情報"
      bodyLabel=""
      loading={false}
      bodyContents={
        <div>
          <div className="w-full md:w-3/5">
            <TextInputField
              label="会社名"
              value={contactData?.company_name}
              providedClassName="form-text-field-border-full"
              placeholder="株式会社サンプル"
              onChange={(e) => updateUserData("company_name", e.target.value)}
              disabled={isViewingHistory}
            />
          </div>

          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label="部署・役職"
              value={contactData?.position_name}
              placeholder="未登録"
              providedClassName="form-text-field-border-full"
              onChange={(e) =>
                handleGenericCheck(
                  "position_name",
                  e.target.value,
                  updateUserData,
                  updateError,
                  32,
                )
              }
              disabled={isViewingHistory}
            />
            {errors.position_name && (
              <p className="text-red-500">
                {UserFieldErrorMessages.positionError}
              </p>
            )}
          </div>

          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label="会社電話番号 （ハイフンなし）"
              providedClassName="form-text-field-border-full"
              placeholder="（例）0312345678"
              value={contactData?.company_tel}
              onChange={(e) =>
                phoneNumberChange(
                  "company_tel",
                  e.target.value,
                  updateUserData,
                  updateError,
                )
              }
              disabled={isViewingHistory}
            />
            {errors.company_tel && (
              <p className="text-red-500">
                {UserFieldErrorMessages.telephoneNumberError}
              </p>
            )}
            <p className="mt-2 text-mayo-light-gray">
              {messages.user.personal_tel_or_company_tel_required}
            </p>
          </div>

          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label="会社FAX番号 （ハイフンなし）"
              providedClassName="form-text-field-border-full"
              value={contactData?.company_fax}
              placeholder="（例）0312345678"
              onChange={(e) =>
                phoneNumberChange(
                  "company_fax",
                  e.target.value,
                  updateUserData,
                  updateError,
                )
              }
              disabled={isViewingHistory}
            />
            {errors.company_fax && (
              <p className="text-red-500">
                {UserFieldErrorMessages.faxNumberError}
              </p>
            )}
          </div>

          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label={"会社郵便番号 （ハイフンなし）"}
              disabled={isViewingHistory}
              value={contactData?.company_postal_code}
              providedClassName="form-text-field-border-full"
              placeholder="1234567"
              onChange={(e) =>
                handlePostCodeChange(
                  "company_postal_code",
                  e.target.value,
                  updateUserData,
                  updateError,
                )
              }
            />
            {errors.company_postal_code && (
              <p className="text-red-500">
                {TenantFieldErrorMessages.postcodeError}
              </p>
            )}
          </div>
          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label="会社住所"
              providedClassName="form-text-field-border-full"
              className={
                isViewingHistory
                  ? "form-text-field-border-gray"
                  : "form-text-field-border"
              }
              value={contactData?.company_address}
              disabled={isViewingHistory}
              placeholder="東京都中央区サンプル町1-2-3"
              onChange={(e) =>
                updateUserData("company_address", e.target.value)
              }
            />
            {errors.company_address && (
              <p className="text-red-500">
                {TenantFieldErrorMessages.postcodeError}
              </p>
            )}
          </div>
          <div className="divider mt-5 mb-6"></div>

          <div className="w-full md:w-3/5">
            <TextInputField
              label="会社ホームページ"
              providedClassName="form-text-field-border-full"
              value={contactData?.company_home_page}
              placeholder="https://www.example.com"
              onChange={(e) =>
                updateUserData("company_home_page", e.target.value.trim())
              }
              disabled={isViewingHistory}
            />
          </div>
        </div>
      }
    />
  );
};
